// src/pages/AboutPage.jsx
import React from 'react';

// Image – adjust path if needed
import Book15 from '../Images/Book15.jpg';

import { theme } from '../utils/constants';

export default function AboutPage() {
  return (
    <section style={{ padding: '6rem 24px', background: 'white' }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
        <h2
          style={{
            textAlign: 'center',
            fontSize: '2.8rem',
            marginBottom: '3.5rem',
            fontFamily: "'Roboto Slab', serif",
            position: 'relative'
          }}
        >
          About the Store
          <span
            style={{
              position: 'absolute',
              bottom: '-14px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '100px',
              height: '4px',
              background: theme.accent,
              borderRadius: '2px'
            }}
          />
        </h2>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))',
            gap: '4rem',
            alignItems: 'center'
          }}
        >
          {/* Author Image */}
          <div style={{ borderRadius: '16px', overflow: 'hidden', boxShadow: theme.shadowMd }}>
            <img
              src={Book15}
              alt="Author Musonda"
              style={{ width: '100%', height: 'auto', display: 'block' }}
            />
          </div>

          {/* Text Content */}
          <div>
            <h3
              style={{
                fontSize: '2.2rem',
                marginBottom: '1.5rem',
                fontFamily: "'Roboto Slab', serif"
              }}
            >
              Musonda
            </h3>

            <p style={{ marginBottom: '1.5rem', color: theme.textLight, lineHeight: 1.8 }}>
              Musonda is an internationally acclaimed author known for her captivating storytelling and richly developed characters.
            </p>

            <p style={{ marginBottom: '1.5rem', color: theme.textLight, lineHeight: 1.8 }}>
              Her debut novel quickly became a bestseller and established her as a prominent voice in contemporary fiction.
            </p>

            <p style={{ color: theme.textLight, lineHeight: 1.8 }}>
              When she's not writing, Musonda enjoys mentoring aspiring authors and exploring new sources of inspiration.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}